import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "form-group",
  style: {"width":"270px","margin-right":"5px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Dates", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_timezone_picker = _resolveComponent("timezone-picker")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["date-range-picker", {'d-flex': _ctx.display === 'inline', 'flex-row': _ctx.display === 'inline'}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createBlock(_component_date_picker, {
        onClick: _cache[1] || (_cache[1] = () => _ctx.opened = true),
        open: _ctx.opened,
        value: _ctx.dateRangeRef,
        type: "datetime",
        range: "",
        onChange: _ctx.setDate,
        editable: true,
        "time-picker-options": {start: '00:00', step:'00:30' , end: '23:30', format: 'HH:mm' },
        "show-time-panel": false,
        format: _ctx.format,
        "input-class": 'form-control form-control-solid form-control-sm',
        shortcuts: _ctx.shortcuts
      }, {
        footer: _withCtx((footerProps) => [
          _createVNode(_component_time_range_picker, {
            modelValue: _ctx.dateRangeRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRangeRef) = $event)),
            block_minutes: _ctx.block_minutes
          }, null, 8, ["modelValue", "block_minutes"])
        ]),
        _: 1
      }, 8, ["open", "value", "onChange", "format", "shortcuts"])), [
        [_directive_click_outside, {clb: _ctx.closePicker, target: '.mx-datepicker-main'}]
      ])
    ]),
    _createVNode(_component_timezone_picker, {
      timezone: _ctx.timezoneRef,
      "onUpdate:timezone": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timezoneRef) = $event)),
      style: {"width":"120px"}
    }, null, 8, ["timezone"])
  ], 2))
}